export default __webpack_public_path__ + "static/6-d2a4e770a5909901986af982fef42c84.png";